import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import * as qs from 'querystringify';
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { requestV1Cgi, RetCode } from "../data-source/network-request";
export var CreateType = /*#__PURE__*/function (CreateType) {
  CreateType[CreateType["CREATE_TYPE_ONLY_META"] = 0] = "CREATE_TYPE_ONLY_META";
  CreateType[CreateType["CREATE_TYPE_EMPTY_DOC"] = 1] = "CREATE_TYPE_EMPTY_DOC";
  CreateType[CreateType["CREATE_TYPE_FROM_TEMPLATE"] = 2] = "CREATE_TYPE_FROM_TEMPLATE";
  CreateType[CreateType["CREATE_TYPE_JUST_SYNC"] = 3] = "CREATE_TYPE_JUST_SYNC";
  CreateType[CreateType["CREATE_TYPE_FROM_DOC"] = 4] = "CREATE_TYPE_FROM_DOC";
  CreateType[CreateType["CREATE_TYPE_FROM_MYTEMPLATE"] = 5] = "CREATE_TYPE_FROM_MYTEMPLATE";
  CreateType[CreateType["CREATE_TYPE_FROM_OCR"] = 6] = "CREATE_TYPE_FROM_OCR";
  CreateType[CreateType["CREATE_TYPE_FOR_PREVIEW"] = 7] = "CREATE_TYPE_FOR_PREVIEW";
  CreateType[CreateType["CREATE_TYPE_FROM_PREVIEW"] = 8] = "CREATE_TYPE_FROM_PREVIEW";
  CreateType[CreateType["CREATE_TYPE_COPY_ASYNC"] = 9] = "CREATE_TYPE_COPY_ASYNC";
  CreateType[CreateType["CREATE_TYPE_COPY_QUERY"] = 10] = "CREATE_TYPE_COPY_QUERY";
  CreateType[CreateType["CREATE_TYPE_OFFLINE"] = 11] = "CREATE_TYPE_OFFLINE";
  CreateType[CreateType["CREATE_TYPE_FILE"] = 12] = "CREATE_TYPE_FILE";
  CreateType[CreateType["CREATE_TYPE_FILE_SAVETO"] = 13] = "CREATE_TYPE_FILE_SAVETO";
  CreateType[CreateType["CREATE_TYPE_TIM_FILE_TRANS"] = 14] = "CREATE_TYPE_TIM_FILE_TRANS";
  CreateType[CreateType["CREATE_TYPE_FROM_TRANSLATE"] = 15] = "CREATE_TYPE_FROM_TRANSLATE";
  return CreateType;
}({});
/**
 * 修改文件夹名称
 */
export var CreateDocRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(CreateDocRequest, _DriveRequest);
  var _super = _createSuper(CreateDocRequest);
  function CreateDocRequest() {
    _classCallCheck(this, CreateDocRequest);
    return _super.apply(this, arguments);
  }
  _createClass(CreateDocRequest, [{
    key: "request",
    value: function request(payload) {
      if (!this.params.redirect) return requestV1Cgi(payload);
      return Promise.resolve({
        retcode: 0,
        cgicode: 0,
        msg: '',
        doc_url: "".concat(location.origin).concat(payload.url, "?").concat(payload.data),
        doc_id: {
          pad_id: ''
        }
      });
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      var _params$createType, _params$hum, _params$addToRecent, _params$redirect, _params$isMiniProgram;
      return {
        method: 'post',
        url: '/cgi-bin/online_docs/createdoc_new',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify({
          xsrf: getXsrfToken(),
          doc_type: params.docType,
          title: params.title,
          pad_id: params.padId,
          folder_id: params.folderId,
          domain_id: params.domain_id || DEFAULT_DOMAIN_ID,
          create_type: (_params$createType = params.createType) !== null && _params$createType !== void 0 ? _params$createType : params.templateId ? CreateType.CREATE_TYPE_FROM_TEMPLATE : CreateType.CREATE_TYPE_EMPTY_DOC,
          data_ver: params.dataVer,
          template_id: params.templateId,
          template_version: params.templateVer,
          hum: Number((_params$hum = params.hum) !== null && _params$hum !== void 0 ? _params$hum : true),
          dont_add_recent: Number((_params$addToRecent = params.addToRecent) !== null && _params$addToRecent !== void 0 ? _params$addToRecent : true),
          // 注: 感觉这个参数名有毒
          redirect: Number((_params$redirect = params.redirect) !== null && _params$redirect !== void 0 ? _params$redirect : false),
          newEmptyDoc: 0,
          // TODO: 新建 doc 时是否直接进入编辑态。0：不进入，1：进入，默认移动端新建 doc 直接进入编辑态
          isMiniProgram: Number((_params$isMiniProgram = params.isMiniProgram) !== null && _params$isMiniProgram !== void 0 ? _params$isMiniProgram : false),
          // TODO: 兼容参数__wxjs_environment=miniprogram
          source1: params.source1
        })
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (response.retcode !== RetCode.Success) {
        throw new DriveApiError({
          name: 'CreateDocResultError',
          message: response.msg,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
      return {
        id: response.doc_id.pad_id,
        url: response.doc_url
      };
    }
  }]);
  return CreateDocRequest;
}(DriveRequest);
var DEFAULT_DOMAIN_ID = '300000000';
//# sourceMappingURL=create-doc.js.map